function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) {
        resolve(value);
    } else {
        Promise.resolve(value).then(_next, _throw);
    }
}
function _async_to_generator(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
        });
    };
}
// Make sure we set ignoreUsage to true when archiving an application
const applicationMiddleware = (db)=>{
    db.$use(/*#__PURE__*/ function() {
        var _ref = _async_to_generator(function*(params, next) {
            if (params.model === "Application" && [
                "create",
                "update"
            ].includes(params.action)) {
                if (params.args && params.args.data && params.args.data.archivedAt) {
                    params.args.data.ignoreUsage = true;
                }
            }
            const result = yield next(params);
            return result;
        });
        return function(params, next) {
            return _ref.apply(this, arguments);
        };
    }());
};
export default applicationMiddleware;
